if (!customElements.get('escadron-rewards')) {
  class EscadronRewards extends HTMLElement {
    connectedCallback() {
      this.giftVariant = Number(this.dataset.giftVariant);
      this.giftThreshold = Number(this.dataset.giftThreshold);
      this.syncGift();
    }

    async syncGift() {
      if (window.escadronGiftSyncing) return;
      window.escadronGiftSyncing = true;
      try {
        const cart = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
        const giftLine = cart.items.find((item) => item.variant_id === this.giftVariant);
        const eligible = cart.total_price >= this.giftThreshold;
        let body = null;
        let endpoint = null;

        if (eligible && !giftLine) {
          endpoint = window.Shopify.routes.root + 'cart/add.js';
          body = { items: [{ id: this.giftVariant, quantity: 1, properties: { _escadron_gift: 'true' } }], sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer', sections_url: window.location.pathname };
        } else if (!eligible && giftLine) {
          endpoint = window.Shopify.routes.root + 'cart/change.js';
          body = { id: giftLine.key, quantity: 0, sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer', sections_url: window.location.pathname };
        } else if (giftLine && giftLine.quantity !== 1) {
          endpoint = window.Shopify.routes.root + 'cart/change.js';
          body = { id: giftLine.key, quantity: 1, sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer', sections_url: window.location.pathname };
        }

        if (!endpoint) return;
        const state = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then((response) => response.json());
        this.renderSections(state.sections || {});
      } catch (error) {
        console.error('Escadron rewards:', error);
      } finally {
        window.escadronGiftSyncing = false;
      }
    }

    renderSections(sections) {
      const replacements = [
        ['cart-drawer', '#CartDrawer'],
        ['cart-icon-bubble', '#cart-icon-bubble'],
        ['main-cart-items', '#main-cart-items'],
        ['main-cart-footer', '#main-cart-footer']
      ];
      replacements.forEach(([sectionId, selector]) => {
        if (!sections[sectionId]) return;
        const current = document.querySelector(selector);
        const incoming = new DOMParser().parseFromString(sections[sectionId], 'text/html').querySelector(selector);
        if (current && incoming) current.replaceWith(incoming);
      });
    }
  }
  customElements.define('escadron-rewards', EscadronRewards);
}

